import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'

export default class ProfileQuestionsLoader extends Component {
  static propTypes = {
    // modulesCount: PropTypes.number,
  }

  static defaultProps = {}

  render() {
    return (
      <ContentLoader primaryOpacity={0.5} secondaryOpacity={0.5} height={60}>
        <rect x={0} y={25} rx="1" ry="1" width={100} height={8} />

        <rect x={340} y={2} rx="1" ry="1" width={65} height={13} />
        <rect x={380} y={25} rx="1" ry="1" width={25} height={8} />
        <rect x={350} y={25} rx="1" ry="1" width={25} height={8} />

      </ContentLoader>
    )
  }
}
